'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFirstMessageText = undefined;

var _reselect = require('reselect');

var _getAvailabilityAwayMessage = require('../../availability/selectors/getAvailabilityAwayMessage');

var _getInitialMessageText = require('../../selectors/widgetDataSelectors/getInitialMessageText');

var _getIsBotInAwayMode = require('../../availability/selectors/getIsBotInAwayMode');

var _getAvailabilityOfficeHoursWillReturnMessage = require('../../availability/selectors/getAvailabilityOfficeHoursWillReturnMessage');

var getFirstMessageText = exports.getFirstMessageText = (0, _reselect.createSelector)([_getAvailabilityAwayMessage.getAvailabilityAwayMessage, _getInitialMessageText.getInitialMessageText, _getIsBotInAwayMode.getIsBotInAwayMode, _getAvailabilityOfficeHoursWillReturnMessage.getAvailabilityOfficeHoursWillReturnMessage], function (awayMessage, initialMessageText, isBotInAwayMode, availabilityOfficeHoursWillReturnMessage) {
  if (isBotInAwayMode) {
    return awayMessage || availabilityOfficeHoursWillReturnMessage;
  }
  return awayMessage || initialMessageText;
});